import { Button, Text } from '@medly-components/core';
import styled from 'styled-components';
import { ReactComponent as BlueWave } from '../../assets/svg/blue-wave.svg';
import { ReactComponent as YellowWave } from '../../assets/svg/yellow-wave.svg';
import { ReactComponent as IllustrationSvg } from '../../assets/svg/illustration.svg';

export const ContentWrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 3.2rem;
    box-sizing: border-box;
    position: relative;
    min-height: 65rem;
    overflow: hidden;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        min-height: 45rem;
    }
`;

export const Illustration = styled(IllustrationSvg)`
    width: 25.6rem;
    height: 22.5rem;
    margin-bottom: 2.4rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        width: 15.2rem;
        height: 13.2rem;
        margin-bottom: 1.6rem;
    }
`;

export const Header = styled(Text)`
    font-size: 4rem;
    line-height: 4.8rem;
    margin-bottom: 1.6rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        font-size: 2.4rem;
        line-height: 3.2rem;
        margin-bottom: 0.8rem;
    }
`;

export const ReloadButton = styled(Button)`
    margin-top: 4.8rem;
    width: 33.6rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        width: 26.4rem;
    }
`;

export const TopLeftVector = styled(BlueWave)`
    position: absolute;
    left: -8rem;
    top: 0;
    transform: rotate(180deg);

    @media (max-width: ${({ theme }) => {
            return theme.breakpoints.S.max;
        }}px) {
        left: -10rem;
        top: -7rem;
    }
`;

export const BottomRightVector = styled(YellowWave)`
    display: flex;
    position: absolute;
    bottom: -5rem;
    right: 0;

    @media (max-width: ${({ theme }) => {
            return theme.breakpoints.S.max;
        }}px) {
        right: -12.3rem;
        transform: scale(0.6);
        bottom: -8rem;
    }
`;
